
import { useForm } from "react-hook-form";
import Input from "../../../components/input/Input";
import Panel from "../../../components/panel/panel";
import { useEffect } from "react";






const IbJuridicoCreated = ({ ibjuridico_config }) => {

  const { control, errors, setValue, formState: form } = useForm();



  useEffect(() => {
    if (ibjuridico_config) {
//      console.log(ibjuridico_config)
      // Verifica se o ibjuridico_config existe antes de definir os valores
      setValue("name", ibjuridico_config.name);
      setValue("doc", ibjuridico_config.cpf_cnpj);
      setValue("email", ibjuridico_config.email);
      setValue("contact", ibjuridico_config.telefone);
      setValue("cep", ibjuridico_config.endereco.cep);
      setValue("num", ibjuridico_config.endereco.numero);
      setValue("complement", ibjuridico_config.endereco.complemento);
      setValue("city", ibjuridico_config.endereco.cidade);
      setValue("state", ibjuridico_config.endereco.estado);
      setValue("address", ibjuridico_config.endereco.endereco);
      setValue("neighborhood", ibjuridico_config.endereco.bairro);
      setValue("token", ibjuridico_config.token);
    }
  }, [ibjuridico_config, setValue]); // Inclua setValue nas dependências do useEffect



  return (
    <>
      <Panel >
        <div className="mb-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <label className="fw-bold fs-4 text-teal">
                <i className="fa-solid fa-landmark"></i> Dados da Empresa
              </label>
            </div>
          </div>
          <hr />
          <div className="row gx-3">
            <div className="col-md-3">
              <Input

                disabled={true}
                isRequired
                type="text"
                control={control}
                errors={errors}
                label="Nome"
                name="name"
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <Input
                control={control}
                disabled={true}
                errors={errors}
                maskChar={null}
                required
                name="doc"
                label="CPF / CNPJ "
                className={`input-cpf`}
              />
            </div>
            <div className="col-md-3 mb-3">
              <Input

                disabled={true}
                isRequired
                name="email"
                errors={errors}
                control={control}
                type="email"
                label="E-mail"
              />
            </div>
            <div className="col-md-3">
              <Input

                disabled={true}
                name={`contact`}
                mask="(99) 99999-999?9"
                control={control}
                isRequired
                errors={errors}
                label={`Telefone`}
              />
            </div>
          </div>
        </div>
        <div className="mt-3 mb-3">
          <label className="fw-bold fs-4 text-teal">
            <i className="fa-solid fa-map-location"></i> Endereço da Empresa
          </label>
          <hr />
          <div className="row gx-3">
            <div className="col-md-3">
              <Input

                disabled={true}
                name="cep"
                mask="99999-999"
                control={control}
                errors={errors}
                isRequired
                label={`CEP `}
              />
            </div>
            <div className="col-md-3">
              <Input
                disabled={true}
                name="num"
                control={control}
                errors={errors}
                
                label={`Número *`}
                isRequired
              />
            </div>
            <div className="col-md-6">
              <Input
                disabled={true}
                name="complement"
                control={control}
                errors={errors}

                label={`Complemento`}
              />
            </div>
            <div className="col-md-3 mt-2">
              <Input
                disabled={true}
                name="city"
                control={control}
                errors={errors}
                label={`Cidade`}
                isRequired
              />
            </div>

            <div className="col-md-3 mt-2">
              <Input
                disabled={true}
                name="state"
                label={`Estado`}
                errors={errors}
                control={control}

              />
            </div>
            <div className="col-md-3 mt-2">
              <Input
                disabled={true}
                name="address"
                control={control}
                errors={errors}
                label={`Rua `}
                isRequired
              />
            </div>
            <div className="col-md-3 mt-2">
              <Input
                disabled={true}
                name="neighborhood"
                control={control}
                errors={errors}
                label={`Bairro `}
                isRequired
              />
            </div>
          </div>
        </div>
        <div className="mb-3">
          <div className="d-flex justify-content-between align-items-center">
            <label className="fw-bold fs-4 text-teal">
              <i className="fa-solid fa-landmark"></i> Token de Integração
            </label>
          </div>
          <hr />
          <div className="row gx-3 align-items-center"> {/* Usando a grid para alinhar o conteúdo */}
            <div className="col-md-6">
              <Input
                disabled={true}
                name="token"
                control={control}
                isRequired
                errors={errors}
                label="Token"
              />
            </div>
            {/* Div ao lado direito do input com proporção col-md-6 */}
            <div className="col-md-6">
              <span

                className="d-flex align-items-center justify-content-center p-2 text-success rounded fs-5" style={{ height: '38px', fontsize: "12px" }}>
                <i className="fa fa-check-circle me-2"></i> {/* Ícone de check verde */}
                Ib Jurídico Configurado
              </span>
            </div>
          </div>
        </div>




      </Panel>


    </>
  );
};

export default IbJuridicoCreated;
